import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const branchApplicationReview = () => ({
    header : "Branch application review",
    navigation : {
        next : ROUTE_PATH.PAYMENT_PREVIEW
    },
    navigationRenewal : {
        next : ROUTE_PATH.PAYMENT_PREVIEW
    }
})

const branchApplicationReviewSlice = createSlice({
    name : "branchApplicationReview",
    initialState : branchApplicationReview(),
    reducers : {} 
})

export default branchApplicationReviewSlice.reducer